"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchState = exports.returnState = exports.loadingState = exports.viewState = exports.state = void 0;

var _recoil = require("recoil");

var state = (0, _recoil.atom)({
  key: 'globalState',
  "default": {
    topActions: []
  }
});
exports.state = state;
var viewState = (0, _recoil.atom)({
  key: 'ViewSelector',
  "default": null
});
exports.viewState = viewState;
var loadingState = (0, _recoil.atom)({
  key: 'loadingState',
  "default": {
    loading: false
  }
});
exports.loadingState = loadingState;
var returnState = (0, _recoil.atom)({
  key: 'returnState',
  "default": ''
});
exports.returnState = returnState;
var searchState = (0, _recoil.atom)({
  key: 'search',
  "default": {
    query: '',
    type: 'free-images'
  }
});
exports.searchState = searchState;